import React from "react";
import ChangePageTitle from "../components/change-title-page";
import AboutComponents from "../components/components-about";
// import axios from "axios";
// import { useState, useEffect } from "react";
import { useAboutHeader } from "../hooks/apis/headers";

function About() {
  const { data: aboutData, isLoading, error } = useAboutHeader();
  //   const [Title, setTitle] = useState("");

  //   useEffect(() => {
  //     axios
  //       .get("https://panel.baghban.restaurant/api/header/about-us")
  //       .then((response) => {
  //         setTitle(response.data.title);
  //         // setslideText(response.data.spotlites[0].text);
  //         console.log(response.data);
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //       });
  //   }, []);

  if (isLoading) return <div className="active loading">
    <img src="/images/loading.svg" className="img-fluid" />
  </div>;
  if (error) return <p>Error</p>;
  return (
    <>
      <ChangePageTitle pageTitle={`${aboutData.title}| رستوران باغبان`} />
      <AboutComponents />
    </>
  );
}

export default About;
